module.exports = __webpack_public_path__ + "img/video_3.b9038fde.gif";